(() => {
  const registry = window.NipponVinoWineAtlasRenderers = window.NipponVinoWineAtlasRenderers || {};
  const FixedMapRenderer = registry.FixedMapRenderer;
  if (!FixedMapRenderer) return;

  class ClassicMapRenderer extends FixedMapRenderer {
    async mount(container, data, state = {}) {
      await super.mount(container, data, state);
      this.controller.dataset.mapRenderer = 'classic';
      this.svg?.classList.remove('wine-atlas-fixed-map');
      this.svg?.classList.add('wine-atlas-classic-map');
      this.svg?.setAttribute('aria-label', 'Klassische vollständige Japan-Weinkarte');
    }
  }

  registry.classic = ClassicMapRenderer;
})();
